import {getApp, getApps, initializeApp} from "firebase/app";
import {getFirestore} from "firebase/firestore";
import {getStorage} from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyCimxHI8ZnMFx0GCx6-zbQprLbWY3_uO6I",
    authDomain: "deliveryapp-26891.firebaseapp.com",
    databaseURL: "https://deliveryapp-26891-default-rtdb.firebaseio.com",
    projectId: "deliveryapp-26891",
    storageBucket: "deliveryapp-26891.appspot.com",
    messagingSenderId: "372666469715",
    appId: "1:372666469715:web:7fa764be887dab8f46e5a6",
    measurementId: "G-KV6D5GFCTJ"
};

const app = getApps.length > 0 ? getApp() : initializeApp(firebaseConfig);

const firestore = getFirestore(app);
const storage = getStorage(app);

export {app, firestore, storage};